module.exports = __webpack_public_path__ + "static/cate-Normal-72c5b5421037e7a8dd41774f97a2ca1b.jpg";